import type { IDailySummaryResponse, IOperator, IPortalExport, IRoundDetails, ITransactionResponse } from '../types';
import apiClient from './apiClient';

const toSearchParams = (params: Record<string, unknown>): Record<string, string | number | boolean> =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null)) as Record<
    string,
    string | number | boolean
  >;

export interface IDailySummaryParams {
  startDate?: string;
  endDate?: string;
  operatorId?: string;
  currency?: string;
  pageNo?: number;
  pageSize?: number;
  [key: string]: unknown;
}

export const getDailySummary = async (params: IDailySummaryParams): Promise<IDailySummaryResponse> => {
  return apiClient
    .get('reports/daily-summary', { searchParams: toSearchParams(params) })
    .json<{ data: IDailySummaryResponse }>()
    .then((res) => res.data);
};

export interface ITransactionParams {
  startDate?: string;
  endDate?: string;
  operatorId?: string;
  roundId?: string;
  betTxnId?: string;
  platformTransactionId?: string;
  externalPlayerId?: string;
  transactionType?: string;
  roundStatus?: string;
  pageNo?: number;
  pageSize?: number;
  [key: string]: unknown;
}

export const getTransactions = async (params: ITransactionParams): Promise<ITransactionResponse> => {
  return apiClient
    .get('reports/transactions', { searchParams: toSearchParams(params) })
    .json<{ data: ITransactionResponse }>()
    .then((res) => res.data);
};

export const getOperators = async (): Promise<IOperator[]> => {
  return apiClient
    .get('operators')
    .json<{ data: IOperator[] }>()
    .then((res) => res.data);
};

export const getRoundDetails = (betTxnId: string): Promise<IRoundDetails> =>
  apiClient
    .get('reports/round-details', { searchParams: { betTxnId } })
    .json<{ success: boolean; data: IRoundDetails }>()
    .then((r) => r.data);

export const triggerExport = (type: string, filters: Record<string, unknown>): Promise<{ exportId: string }> =>
  apiClient
    .post('reports/exports', { json: { type, filters } })
    .json<{ success: boolean; data: { exportId: string } }>()
    .then((r) => r.data);

export const listExports = (): Promise<IPortalExport[]> =>
  apiClient
    .get('reports/exports')
    .json<{ success: boolean; data: IPortalExport[] }>()
    .then((r) => r.data);

export const getExportDownloadUrl = (exportId: string): Promise<{ url: string }> =>
  apiClient
    .get(`reports/exports/${exportId}/download`)
    .json<{ success: boolean; data: { url: string } }>()
    .then((r) => r.data);

export const getPortalConfig = async (): Promise<{
  maxDateRangeDays: number;
}> => {
  return apiClient
    .get('config/portal')
    .json<{ data: { maxDateRangeDays: number } }>()
    .then((res) => res.data);
};
